var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Box, Center, Flex, FormControl, FormLabel, Input, Spinner, Text, Icon } from '@chakra-ui/react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { StoreContext } from '@/app/uistore/Rootstore';
import { BaseDialog, BaseDialogState } from '@/app/UIComponents/BaseDialog';
import { MasterKeyLoadStatus } from '../uistore/AdminStore';
import { FontSize } from '../const/AppDefaults';
import { MdCloudDownload } from '@react-icons/all-files/md/MdCloudDownload';
export class MasterPasswordDialogState {
    constructor() {
        this.open = false;
        this.basedialogState = new BaseDialogState();
        this.password = "";
        makeObservable(this);
        this.basedialogState.setHeaderLabel("Master Password");
        this.basedialogState.setDisableOkButton(true);
    }
    saveMasterPassword() {
    }
    setOpen(open) {
        this.open = open;
        this.basedialogState.setOpen(open);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], MasterPasswordDialogState.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], MasterPasswordDialogState.prototype, "password", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], MasterPasswordDialogState.prototype, "setOpen", null);
let MasterPasswordDialog = class MasterPasswordDialog extends React.Component {
    constructor(prop) {
        super(prop);
        this.props.state.basedialogState.onClose = () => this.closed();
        this.props.state.basedialogState.onOpen = () => this.opened();
    }
    componentDidMount() {
        this.opened();
    }
    componentDidUpdate() {
        this.updateDialog();
    }
    opened() {
        const rstore = this.context;
        rstore.adminStore.checkHasMasterKey();
        this.updateDialog();
    }
    closed() {
        const rstore = this.context;
        rstore.adminStore.reset();
        this.props.state.setOpen(false);
    }
    updateDialog() {
        const rstore = this.context;
        this.props.state.basedialogState.setDisableOkButton(true);
        if (rstore.adminStore.hasMasterKey) {
            this.props.state.basedialogState.setOkLabel('Reveal Password');
            this.props.state.basedialogState.onOk = () => rstore.adminStore.getAndShowMasterKey();
        }
        else {
            this.props.state.basedialogState.setOkLabel('Save Password');
            this.props.state.basedialogState.onOk = () => rstore.adminStore.saveMasterPassword();
        }
    }
    componentWillUnmount() {
        const rstore = this.context;
        rstore.adminStore.reset();
    }
    setMasterPasswordInput(input) {
        const rstore = this.context;
        this.enableButton(input);
        rstore.adminStore.setMasterPasswordInput(input);
    }
    enableButton(input) {
        if (input) {
            this.props.state.basedialogState.setDisableOkButton(false);
        }
        else {
            this.props.state.basedialogState.setDisableOkButton(true);
        }
    }
    setUserPassword(input) {
        const rstore = this.context;
        this.enableButton(input);
        if (input) {
            rstore.adminStore.setUserPasswordInput(input);
        }
    }
    buildUserPasswordInput() {
        return React.createElement(FormControl, { w: '300px', id: "userpassword", isRequired: true },
            React.createElement(FormLabel, null, "Login Password"),
            React.createElement(Input, { type: 'password', id: 'userpassword', placeholder: "Password", onChange: (e) => this.setUserPassword(e.currentTarget.value) }));
    }
    downloadMasterPassword() {
        const rstore = this.context;
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(rstore.adminStore.masterkey));
        element.setAttribute('download', "letrwing_masterpassword.txt");
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }
    dialog() {
        const rstore = this.context;
        if (rstore.adminStore.loadStatus === MasterKeyLoadStatus.Loading || rstore.adminStore.loadStatus === MasterKeyLoadStatus.Unknown) {
            return React.createElement(Flex, { justify: 'center', align: 'center', w: '100%', mt: '30px', h: '100%' },
                React.createElement(Spinner, null));
        }
        return (React.createElement(Box, { w: '100%', mt: '30px' },
            !rstore.adminStore.hasMasterKey && React.createElement(Box, { mt: '30px' },
                React.createElement(Center, null, this.buildUserPasswordInput()),
                React.createElement(Center, { mt: '20px' },
                    React.createElement(FormControl, { w: '300px', id: "mp", isRequired: true },
                        React.createElement(FormLabel, null, "Master Password"),
                        React.createElement(Input, { type: 'password', id: 'mp', placeholder: "Master Password", onChange: (e) => this.setMasterPasswordInput(e.currentTarget.value) })))),
            rstore.adminStore.hasMasterKey && React.createElement(Box, { mt: '30px' },
                !rstore.adminStore.revealMasterKey &&
                    React.createElement(Center, null, this.buildUserPasswordInput()),
                rstore.adminStore.revealMasterKey &&
                    React.createElement(Flex, { mt: '5px', fontSize: 24, style: { fontWeight: 'bold' }, justify: 'center', align: 'center' },
                        React.createElement(Text, { fontSize: FontSize.HeaderFontSize, fontWeight: 'bold' }, rstore.adminStore.masterkey),
                        React.createElement(Icon, { _hover: { cursor: 'pointer' }, ml: '10px', onClick: () => {
                                this.downloadMasterPassword();
                            }, as: MdCloudDownload })))));
    }
    render() {
        return (React.createElement(BaseDialog, { body: this.dialog(), state: this.props.state.basedialogState }));
    }
};
MasterPasswordDialog.contextType = StoreContext;
MasterPasswordDialog = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], MasterPasswordDialog);
export { MasterPasswordDialog };
